import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { stateOptionsSample, chooseOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Router, ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from '../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DocumentUploadComponent } from 'src/app/common/document-upload/document-upload.component';
import { ModuleMenu } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-ist-general-information',
  templateUrl: './ist-general-information.component.html',
  styleUrls: ['./ist-general-information.component.scss']
})
export class IstGeneralInformationComponent implements OnInit, IDeactivateComponent {

  uploadedFiles = ["Letter of ..."];
  staticformFields: any;
  stateOptions = stateOptionsSample;
  chooseOptionsConstant = chooseOptionsConstant;
  selectedProduct: any;
  content: any;
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  ApplicationID: any;
  auditID:any;
  auditRevisionNo:any;
  menudata: ModuleMenu;
  therapeuticArea: any[];
  studyType: any[];
  productType: any[];
  studyInvolvesOptions: any[];
  studySponsored: any[];
  requestType: any[];
  generalInformationForm: UntypedFormGroup;
  permission: string = "";
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  @ViewChild('documentUpload') documentUpload: DocumentUploadComponent;

  constructor(
    private modalService: NgbModal,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    private appFunctions: AppFunctionsService,
    private summaryService: IstSummaryService,
    private DatashareSerivce: IstDataShareService,
    private dataShare: IstDataShareService,
    public commonService: CommonService,
    private userService: UserService
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
    //this.setFormPermissions();
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-001');
     
    this.userType = this.userService.getUserType();
    this.DatashareSerivce.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    // this.studyInvolvesOptions = [
    //   { value: "", label: 'Select', checked: true },
    //   { value: "Yes", label: 'Yes' },
    //   { value: "No", label: 'No' }
    // ];

    // this.studySponsored = [
    //   { value: "", label: 'Select', checked: true },
    //   { value: "1", label: 'Individual' },
    //   { value: "2", label: 'Organization' }
    // ];
    // this.requestType = [
    //   { value: "", label: 'Select', checked: true },
    //   { value: "1", label: 'Fund' },
    //   { value: "2", label: 'Product' },
    //   { value: "3", label: 'Both' },
    // ];
    this.generalInformationForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        APPLICATION_CODE: new UntypedFormControl(""),
        APPLICATIONID: new UntypedFormControl(""),
        TITLE_OF_STUDY: new UntypedFormControl(""),
        STUDY_SPONSORED: new UntypedFormControl(""),
        THERAPEUTIC_AREA_ID: new UntypedFormControl(""),
        HAS_OTHER_COMPOUNDS: new UntypedFormControl(""),
        OTHER_COMPOUNDS_DETAILS: new UntypedFormControl(""),
        STUDY_TYPE: new UntypedFormControl(""),
        IS_MULTI_CENTER_INVOLVED: new UntypedFormControl(""),//UntypedFormControl("Yes"),
        REQUEST_TYPE: new UntypedFormControl(""),
        PRODUCTIDS: new UntypedFormControl(""),

      });    
    setTimeout(() => {
      //this.setFormPermissions();
     
    }, 700);
    // if(this.permission=="")
    // {
    //   setTimeout(() => {
    //     this.permission = this.commonService.getPagePermission("IST01");
    //     if (this.documentUpload != undefined && this.documentUpload != null)
    //       this.documentUpload.ScreenMode = this.permission;
    //    },1000);
    // }


    this.summaryService.getGeneralInformation("api/ISTGeneralInfo/GetMasterList?ApplicationID=" + this.ApplicationID).subscribe((summary) => {

      if (summary != null && summary != undefined) {        
        this.therapeuticArea = summary["TherapeuticAreaList"];
        this.therapeuticArea = [{ label: "Select", value: "", checked: true }].concat(this.therapeuticArea);
        this.studyType = summary["StudyTypeList"];
        this.studyType = [{ label: "Select", value: "", checked: true }].concat(this.studyType);
        this.productType = summary["ProductList"];
        this.productType.forEach((item: any) => {
          if (item.IsActive == false)
            item["icon"] = "ieg_inactive_record";
        });

        var productIds = summary["PRODUCTIDS"];
        var productList = [];
        if (productIds != null && productIds != undefined && productIds.length > 0) {
          productList = productIds.split(",");
        }
        // if (summary["ID"] == "" || summary["ID"] == null || summary["ID"] == undefined) {
        //   summary["IS_MULTI_CENTER_INVOLVED"] = "Yes";
        // }
        this.generalInformationForm.patchValue({
          ID: summary["ID"],
          APPLICATION_CODE: summary["APPLICATION_CODE"],
          APPLICATIONID: summary["APPLICATIONID"],
          TITLE_OF_STUDY: summary["TITLE_OF_STUDY"],
          STUDY_SPONSORED: summary["STUDY_SPONSORED"],
          THERAPEUTIC_AREA_ID: summary["THERAPEUTIC_AREA_ID"],
          HAS_OTHER_COMPOUNDS: summary["HAS_OTHER_COMPOUNDS"],
          OTHER_COMPOUNDS_DETAILS: summary["OTHER_COMPOUNDS_DETAILS"],
          STUDY_TYPE: summary["STUDY_TYPE"],
          IS_MULTI_CENTER_INVOLVED: summary["IS_MULTI_CENTER_INVOLVED"],
          REQUEST_TYPE: summary["REQUEST_TYPE"],
          PRODUCTIDS: productList,

        });
        if (this.extendedForm != undefined && this.extendedForm != null) {
          this.extendedForm.rowid = summary["ID"];
          this.extendedForm.getResponse();
        }

        this.permission = summary["PERMISSION"];
        this.setFormPermissions();

        // By using this permission, page state needs to control.
        if (this.permission == "view") {
          this.generalInformationForm.disable();
        }
        else 
        {
          this.generalInformationForm.enable();
        }
      }


    });

  }

  private setFormPermissions()
  {    
    //this.permission = "";
    //this.permission = this.commonService.getPagePermission("IST01");
    if (this.documentUpload != undefined && this.documentUpload != null)
      this.documentUpload.ScreenMode = this.permission;
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
     // this.generalInformationForm.disable();     
    }
  
  if (this.permission == "view") {
   // this.generalInformationForm.disable();
   this.operations = [];
  }
  else {
    this.operations = [
      { name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this }
    ]
  }
    if (this.permission == "view" && this.generalInformationForm!=undefined && this.generalInformationForm!=null) {
      this.generalInformationForm.disable();
    }
    else if(this.generalInformationForm!=undefined && this.generalInformationForm!=null)
    {
      this.generalInformationForm.enable();
    }
  
}
  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.requestType=this.staticformFields.REQUEST_TYPE.GROUP_VALUES_LIST;
        this.requestType = [{ label: "Select", value: null, checked: true }].concat(this.requestType);
        this.studySponsored =this.staticformFields.STUDY_SPONSORED.GROUP_VALUES_LIST;
        this.studySponsored = [{ label: "Select", value: null, checked: true }].concat(this.studySponsored);
        this.studyInvolvesOptions = this.staticformFields.HAS_OTHER_COMPOUNDS.GROUP_VALUES_LIST;
        this.studyInvolvesOptions = [{ label: "Select", value: null, checked: true }].concat(this.studyInvolvesOptions);
      });
  }

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    for (let i = 0; i < this.files.length; i++) {
      let newAttachment = this.files[i].name;
      this.uploadedFiles.push(newAttachment);
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },

    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {
    //debugger;
    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    this.showFiles();
  }

  // operations = [
  //   { name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this }
  // ]

  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.generalInformationForm, this.DatashareSerivce);
  }

  SaveGeneralInfo() {
    if (this.validateControls()) {
      this.generalInformationForm.markAsPristine();
      var formData = this.generalInformationForm.value;
      if (formData.PRODUCTIDS == "" || formData.PRODUCTIDS == undefined) {
        formData.PRODUCTIDS = "";
      }
      else {
        var PROGobj = this.productType.filter(function (element) {
          return formData.PRODUCTIDS.indexOf(element.value) > -1;
        });
        if (PROGobj.length > 0) {
          if (formData.PRODUCTIDS.indexOf(",") === -1) {
            if (Array.isArray(formData.PRODUCTIDS)) {
              formData.PRODUCTIDS = formData.PRODUCTIDS.join(",");
            }
            // else
            // {
            //   formData.PRODUCTIDS = formData.PRODUCTIDS;
            // }
          }
        }
      }

      if (this.ApplicationID == "" || this.ApplicationID == undefined) {
        this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Insert", formData).subscribe((result) => {
          var tempID = result["TransactionID"];
          this.ApplicationID = tempID;
          this.DatashareSerivce.setApplicationID(tempID);
          if (result.Status === 0) {
            this.auditID = result.TransactionCode;
            this.auditRevisionNo=result.Data;
            this.documentUpload.saveDocumentUploads(this.ApplicationID,this.auditID,this.auditRevisionNo).subscribe((resultDoc) => {
              if (resultDoc.Status === 0) {
                this.extendedForm.saveControls(result.TransactionID, tempID, result.TransactionCode).subscribe(result1 => {
                  if (result1.Status === 0) {
                    this.commonService.SuccessBanner(result.Message);
                    this.refreshPage(tempID);
                    this.documentUpload.getFeatureDocuments();
                    if (this.extendedForm != null && this.extendedForm != undefined) {
                      this.extendedForm.getResponse();
                    this.extendedForm.IsFormToched=false;

                    }
                  }
                  else {
                    this.commonService.ValidationBanner(result1.Message);
                    this.documentUpload.getFeatureDocuments();
                    if (this.extendedForm != null && this.extendedForm != undefined) {
                      this.extendedForm.getResponse();
                    }
                  }
                });
              }
              else {
                //this.refreshPage(tempID);
                this.commonService.ValidationBanner(resultDoc.Message);
              }
            });
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.getAppSubmitValidations("api/ISTGeneralInfo/IST_APPInActiveGIValidation?ApplicationID=" + this.ApplicationID + "&therapId=" + formData.THERAPEUTIC_AREA_ID
          + "&StudyTypeId=" + formData.STUDY_TYPE + "&ProductIds=" + formData.PRODUCTIDS
        ).subscribe((resultInactive) => {
          if (resultInactive != null && resultInactive != undefined) {
            if (resultInactive.Status == 0) {
              let dataMsg = resultInactive.Data.Validations[0].FiledsData.join("</br>");
              this.commonService.ValidationBanner(dataMsg);
            }
            else {
              this.summaryService.SaveIstGeneralInfo("api/ISTGeneralInfo/Update", formData).subscribe((result) => {
                if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                  this.auditID =  result.TransactionCode;
                  this.auditRevisionNo=result.Data;
                  this.documentUpload.saveDocumentUploads(this.ApplicationID,this.auditID,this.auditRevisionNo).subscribe((result2) => {
                    if (result2.Status === 0 || result2.ErrorCode === "NOCHANGES") {
                      this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                      
                        if (result1.ErrorCode === "NOCONTROLS") {
                          if (result.ErrorCode === "NOCHANGES" && result2.ErrorCode === "NOCHANGES")
                            this.commonService.ValidationBanner(result.Message);
                          else
                          {
                            this.commonService.SuccessBanner("General Information saved successfully");
                            if (this.extendedForm != null && this.extendedForm != undefined) {
                              this.extendedForm.IsFormToched=false;
                                this.extendedForm.getResponse();
                              }
                          }
                        }
                        else {
                          if (result.ErrorCode === "NOCHANGES" && result2.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                            this.commonService.ValidationBanner(result.Message);
                          }
                          else {
                            this.commonService.SuccessBanner("General Information saved successfully");
                            if (this.extendedForm != null && this.extendedForm != undefined) {
                            this.extendedForm.IsFormToched=false;
                              this.extendedForm.getResponse();
                            }
                          }
                        }
                        this.documentUpload.getFeatureDocuments();

                      });
                    }
                    else {
                      this.commonService.ValidationBanner(result2.Message);
                      // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
                      this.documentUpload.getFeatureDocuments();
                    }
                  });
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                  // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
                  this.documentUpload.getFeatureDocuments();
                }
              });
            }
          }
        });
        // this.generalInformationForm.markAsPristine();
      }

    }
  }

  refreshPage(id: any) {

    this.summaryService.getISTApplicationSummary("api/common/getistapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.ScreenID = data.ID;
      this.commonService.setISTApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "IST";
      this.menudata.operation = "Edit";
      this.menudata.appId = id;
      this.menudata.screenID = id;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.dataShare.setApplicationID(id);
      this.router.navigate(['/home/ist/my-applications/application-ext/:' + id + '/general_information_request'], { skipLocationChange: true, queryParams: { id: id, app_ext: true, module: "ist", screen_type: "my-applications" } })

    });
    this.generalInformationForm.markAsPristine();
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.generalInformationForm.value;

    if (this.staticformFields?.TITLE_OF_STUDY.IS_MANDATORY && this.staticformFields?.TITLE_OF_STUDY.IS_Display) {
      if (formData.TITLE_OF_STUDY === null || formData.TITLE_OF_STUDY === "") {
        $("#TITLE_OF_STUDY").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE_OF_STUDY").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE_OF_STUDY.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#TITLE_OF_STUDY").addClass("ng-untouched ng-valid");
        $("#TITLE_OF_STUDY").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.STUDY_SPONSORED.IS_MANDATORY && this.staticformFields?.STUDY_SPONSORED.IS_Display) {
      if (formData.STUDY_SPONSORED === null || formData.STUDY_SPONSORED === "") {
        $("#STUDY_SPONSORED").addClass("ng-touched ng-invalid validate-error");
        $("#STUDY_SPONSORED").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.STUDY_SPONSORED.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#STUDY_SPONSORED").addClass("ng-untouched ng-valid");
        $("#STUDY_SPONSORED").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.THERAPEUTIC_AREA_ID.IS_MANDATORY && this.staticformFields?.THERAPEUTIC_AREA_ID.IS_Display) {
      if (formData.THERAPEUTIC_AREA_ID === null || formData.THERAPEUTIC_AREA_ID === "" || formData.THERAPEUTIC_AREA_ID === "Select") {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-touched ng-invalid validate-error");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.THERAPEUTIC_AREA_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.REQUEST_TYPE.IS_MANDATORY && this.staticformFields?.REQUEST_TYPE.IS_Display) {
      if (formData.REQUEST_TYPE === null || formData.REQUEST_TYPE === "") {
        $("#REQUEST_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.REQUEST_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUEST_TYPE").addClass("ng-untouched ng-valid");
        $("#REQUEST_TYPE").removeClass("ng-touched ng-invalid validate-error");

        if (formData.REQUEST_TYPE != "1" ){
          if(this.staticformFields?.PRODUCTIDS.IS_MANDATORY && this.staticformFields?.PRODUCTIDS.IS_Display )  {
            if (formData['PRODUCTIDS'] == "" || formData['PRODUCTIDS'] == undefined || formData['PRODUCTIDS'].length == 0) {
              $("#PRODUCTIDS").addClass("ng-touched ng-invalid validate-error");
              $("#PRODUCTIDS").removeClass("ng-untouched ng-valid");
              message += `Please select ${this.staticformFields?.PRODUCTIDS.LABEL_NAME} <br/>`;
              isValid = false;
            }
            else {
              $("#PRODUCTIDS").addClass("ng-untouched ng-valid");
              $("#PRODUCTIDS").removeClass("ng-touched ng-invalid validate-error");
            }
          }
        }
      }
    }

    if (this.staticformFields?.HAS_OTHER_COMPOUNDS.IS_MANDATORY && this.staticformFields?.HAS_OTHER_COMPOUNDS.IS_Display) {
      if (formData.HAS_OTHER_COMPOUNDS === null || formData.HAS_OTHER_COMPOUNDS === "") {
        $("#HAS_OTHER_COMPOUNDS").addClass("ng-touched ng-invalid validate-error");
        $("#HAS_OTHER_COMPOUNDS").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.HAS_OTHER_COMPOUNDS.LABEL_NAME} <br/>`;
        isValid = false;
      } else {

        $("#HAS_OTHER_COMPOUNDS").addClass("ng-untouched ng-valid");
        $("#HAS_OTHER_COMPOUNDS").removeClass("ng-touched ng-invalid validate-error");
      }
      debugger;
        if (formData["HAS_OTHER_COMPOUNDS"] == "1" && this.staticformFields?.OTHER_COMPOUNDS_DETAILS.IS_MANDATORY && this.staticformFields?.OTHER_COMPOUNDS_DETAILS.IS_Display) {
          if (formData.OTHER_COMPOUNDS_DETAILS === null || formData.OTHER_COMPOUNDS_DETAILS === "") {
            $("#OTHER_COMPOUNDS_DETAILS").addClass("ng-touched ng-invalid validate-error");
            $("#OTHER_COMPOUNDS_DETAILS").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.OTHER_COMPOUNDS_DETAILS.LABEL_NAME} <br/>`;
            isValid = false;
          } else {
            $("#OTHER_COMPOUNDS_DETAILS").addClass("ng-untouched ng-valid");
            $("#OTHER_COMPOUNDS_DETAILS").removeClass("ng-touched ng-invalid validate-error");
          }
        }
      }

    if (this.staticformFields?.STUDY_TYPE.IS_MANDATORY && this.staticformFields?.STUDY_TYPE.IS_Display) {
      if (formData.STUDY_TYPE === null || formData.STUDY_TYPE === "") {
        $("#STUDY_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#STUDY_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.STUDY_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#STUDY_TYPE").addClass("ng-untouched ng-valid");
        $("#STUDY_TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.IS_MULTI_CENTER_INVOLVED.IS_MANDATORY && this.staticformFields?.IS_MULTI_CENTER_INVOLVED.IS_Display) {
      if (formData.IS_MULTI_CENTER_INVOLVED === null || formData.IS_MULTI_CENTER_INVOLVED === "") {
        $("#IS_MULTI_CENTER_INVOLVED").addClass("ng-touched ng-invalid validate-error");
        $("#IS_MULTI_CENTER_INVOLVED").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.IS_MULTI_CENTER_INVOLVED.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#IS_MULTI_CENTER_INVOLVED").addClass("ng-untouched ng-valid");
        $("#IS_MULTI_CENTER_INVOLVED").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    var msg = "";
    msg = this.documentUpload.validateControls();
    if (msg != "") {
      message += msg;
      isValid = false;
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }

  requestTypeSelectionChanged(newValue) {
    if (this.generalInformationForm.controls['REQUEST_TYPE'].value == "1") {
      this.generalInformationForm.controls['PRODUCTIDS'].setValue([]);
    }
  }

  canExit() {
    if (this.generalInformationForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

}
